export { DotsHorizontalCircle as default } from './DotsHorizontalCircle';
